import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useTheme} from "@mui/material/styles";
import {useMediaQuery} from "@mui/material";

const AlertDialog = ({open, handleDenied, handleApprove}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open}
      onClose={handleDenied}
      fullScreen={fullScreen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Are you sure?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Currently bot has an open position. Saving new properties or disabling bot right now will terminate the position.
          Doing so could result in money lost.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDenied}>Cancel</Button>
        <Button onClick={handleApprove} autoFocus>
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleDenied: PropTypes.func.isRequired,
  handleApprove: PropTypes.func.isRequired
}

export default AlertDialog
